import { handleActions, createAction } from 'redux-actions';
import mapActions from '@goodwaygroup/react-map-actions';
import update from 'immutability-helper';

// Actions
export const actions = mapActions([
    'FETCH_ENTITY_AUDIT_LOGS',
    'FETCH_ENTITY_AUDIT_LOGS_SUCCESS',
], 'AUDITS');

// Action Creators
export const fetchEntityAuditLogs = createAction(actions.FETCH_ENTITY_AUDIT_LOGS);
export const fetchEntityAuditLogsSuccess = createAction(actions.FETCH_ENTITY_AUDIT_LOGS_SUCCESS);

const initialState = {
    auditModel: null,
    id: null,
    revisions: []
};

// Reducers
export default handleActions({
    [actions.FETCH_ENTITY_AUDIT_LOGS_SUCCESS]: (state, action) => {
        const updatedData = {
            auditModel: { $set: action.payload.auditModel },
            id: { $set: action.payload.id },
            revisions: { $set: action.payload.revisions },
        };

        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/audits/duck.js